import TypeToReducer from 'type-to-reducer';
import set from 'lodash/set';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';
import {
  RESET_PROJECT_FORM,
  GET_PROJECT_BY_ID,
  MODIFY_CUSTOM_FIELD_EDITING_PROJECT, //Groups
  MODIFY_EDITING_PROJECT,
} from 'projects/constants';

export const initialState = {
  isFetchingConfig: false,
  isFetching: false,
  isSaving: false,
  editing: {},
};

export const resetForm = (state) => ({ ...initialState });

export const getByIdPending = (state) => ({ ...state, isFetching: true });

export const getByIdRejected = (state) => ({ ...state, isFetching: false });

export const getByIdFulfilled = (state, { payload }) => ({
  ...state,
  isFetching: false,
  editing: { ...payload.project },
});

export const modifyProject = (state, { payload }) => ({
  ...state,
  editing: {
    ...state.editing,
    ...payload,
  },
});

//Groups
export const modifyCustomField = (state, { payload }) => {
  findAndModify(state.editing._custom, payload);
  return {
    ...state,
    editing: {
      ...state.editing,
      ...payload,
    },
  };
};

export const findAndModify = (_custom, payload) => {
  const keys = Object.getOwnPropertyNames(payload);
  const key = keys[0];
  const value = payload[key];
  let banderaExiste = false;
  _custom.forEach((element) => {
    if (element.key == key) {
      element.value = value;
      banderaExiste = true;
    }
  });
  if (!banderaExiste) _custom.push({ key, value });
  return _custom;
};
//Groups

const reducers = {
  [RESET_PROJECT_FORM]: resetForm,
  [GET_PROJECT_BY_ID]: {
    [PENDING]: getByIdPending,
    [REJECTED]: getByIdRejected,
    [FULFILLED]: getByIdFulfilled,
  },
  [MODIFY_EDITING_PROJECT]: modifyProject,
  [MODIFY_CUSTOM_FIELD_EDITING_PROJECT]: modifyCustomField, //Groups
};

export default TypeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/projects/reducers/projects_form_reducers.js